import { render, staticRenderFns } from "./WhatsNewPage.vue?vue&type=template&id=63fc77c7&scoped=true"
import script from "./WhatsNewPage.vue?vue&type=script&lang=ts"
export * from "./WhatsNewPage.vue?vue&type=script&lang=ts"
import style0 from "./WhatsNewPage.vue?vue&type=style&index=0&id=63fc77c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc77c7",
  null
  
)

export default component.exports